module.exports = __webpack_public_path__ + "static/img/group-logo-CHUV-hachure-black.34bd9a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-logo-CHUV-hachure-black.svg
// module id = W1S7
// module chunks = 1